import { object, string } from 'yup'

export const addressFormSchema = object().shape({
  addressLine1: string()
    .required('Address line 1 is a required field')
    .default(''),
  addressLine2: string().default(''),
  city: string().required('City is a required field').default(''),
  province: string().required('Province is a required field').default(''),
  postalCode: string().required('Postal code is a required field').default(''),
})
